import React, { useState } from "react"

import Typography from "../../components/shared/Typography"
import CustomDomainSection from "../ProfileEdit/CustomDomainSection"

const WebsiteDomain = ({ customDomain, website }) => {
  const [customDomainValue, setCustomDomainValue] = useState(customDomain)

  return (
    <>
      <Typography as="h2" variant="h4" className="mb-4">
        Custom domain
      </Typography>
      <div className="flex w-max flex-col items-start justify-start gap-6 rounded-xl border border-gray-light p-8 md:w-full">
        {/* (2025-04-07) Hiding shortlink as an effort to make Pros focus on custom domain */}
        {/* Check PR "Hide short link and change purchase domain link order" */}
        <CustomDomainSection
          customDomain={customDomainValue}
          setDetailsValues={setCustomDomainValue}
          website={website}
        />
      </div>
    </>
  )
}

export default WebsiteDomain
